<nz-modal
  [nzVisible]="visible"
  nzTitle="Batch Email"
  [nzWidth]="mode ? '70vw' : '520px'"
  [nzMaskClosable]="false"
  [nzFooter]="mode ? footer : null"
  (nzOnCancel)="handleCancel()"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="!mode; else batchContent">
      <div class="transact-send-group">
        <nz-row nzGutter="8">
          <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <button
              type="button"
              class="sender-chooser"
              (click)="selectMode('notification')"
              nz-button
            >
              <div class="content">
                <div class="icon">
                  <i nz-icon nzIconfont="icon-send"></i>
                </div>
                <div class="title">Notification</div>
                <div class="description">
                  Notify your customer via email about the transaction.
                </div>
              </div>
            </button>
          </nz-col>
          <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <button
              type="button"
              class="sender-chooser"
              (click)="selectMode('payment')"
              nz-button
              [disabled]="!allowPayment"
            >
              <div class="icon">
                <i nz-icon nzIconfont="icon-collect-payment"></i>
              </div>
              <div class="title">Payment Collection</div>
              <div class="description">
                Send an email to request payment for the transaction.
              </div>
            </button>
          </nz-col>
        </nz-row>
      </div>
    </ng-container>

    <ng-template #batchContent>
      <form #batchForm="ngForm" nz-form>
        <nz-spin [nzSpinning]="loading" [nzTip]="'Loading...'">
          <nz-row nzGutter="12" class="batch-email-content">
            <nz-col nzMd="10" nzSm="24" nzXs="24">
              <div class="sender-info">
                <div class="block">
                  <div class="title">Subject:</div>
                  <input
                    class="email-template-required-field"
                    nz-input
                    type="text"
                    name="batchSubject"
                    [(ngModel)]="batchSubject"
                    [disabled]="sending"
                  />
                </div>
                <div class="block">
                  <div class="title">Message:</div>
                  <textarea
                    nz-input
                    rows="8"
                    style="resize: none"
                    name="batchMessage"
                    [(ngModel)]="batchMessage"
                    [disabled]="sending"
                  ></textarea>
                  <div class="small-remark">
                    Attachment link will be generated upon submission. Please ensure
                    that the [link] tag stays in the content of the message.
                  </div>
                </div>
              </div>
            </nz-col>

            <nz-col nzMd="14" nzSm="24" nzXs="24">
              <st
                class="batch-mail-table"
                [responsive]="false"
                [page]="{ front: false }"
                [loading]="loading"
                [data]="rows"
                [columns]="columns"
                [scroll]="{ y: '300px' }"
                (change)="change($event)"
              >
                <ng-template st-row="docTpl" let-item>
                  <span class="row-select" (click)="selectRow(item)">{{
                    item.docCode
                  }}</span>
                </ng-template>
                <ng-template st-row="toTpl" let-item>
                  <span class="row-select" (click)="selectRow(item)">{{
                    item.recipientName
                  }}</span>
                </ng-template>
                <ng-template st-row="emailTpl" let-item let-index="index">
                  <div class="row-select" (click)="selectRow(item)">
                    <nz-select
                      nzMode="tags"
                      [nzDropdownStyle]="{ display: 'none' }"
                      [name]="'recipientEmails_' + index"
                      [(ngModel)]="item.recipientEmails"
                      style="width: 100%"
                      [disabled]="sending || !!item.error"
                      (ngModelChange)="updateRowRecipientEmails(item)"
                    >
                      <nz-option
                        *ngFor="let email of item.emailOptions"
                        [nzLabel]="email"
                        [nzValue]="email"
                      ></nz-option>
                    </nz-select>
                  </div>
                </ng-template>
              </st>
            </nz-col>
          </nz-row>
        </nz-spin>
      </form>

    </ng-template>
  </ng-container>

  <ng-template #footer>
    <div class="batch-email-footer">
      <div *ngIf="mode">
        <div class="report-footer-row">
          <div class="report-format-container" *ngIf="hasReportFormats">
            <div class="footer-title">Format:</div>
            <nz-select
              style="margin-right: 6px; max-width: 200px"
              [(ngModel)]="batchSelectedReport"
              name="batchSelectedReport"
              [nzDropdownMatchSelectWidth]="false"
              [nzDropdownClassName]="'format-dropdown'"
              [disabled]="sending"
            >
              <nz-option
                nzCustomContent
                [nzLabel]="format.displayName"
                [nzValue]="format.reportUrl"
                *ngFor="let format of reportFormats"
              >
                <span *ngIf="!format.isDefault">{{ format.displayName }}</span>
                <strong *ngIf="format.isDefault">{{ format.displayName }}</strong>
              </nz-option>
            </nz-select>
          </div>
          <label class="unhighlightable" nz-checkbox [(ngModel)]="batchSendCopy" name="batchSendCopy">
            Send me a copy
          </label>
          <label
            class="unhighlightable"
            nz-checkbox
            [(ngModel)]="batchIncludeAttachment"
            name="batchIncludeAttachment"
            [nzDisabled]="!hasReportFormats"
            *ngIf="hasReportFormats"
          >
            Include PDF File
          </label>
        </div>
      </div>
      <div class="batch-email-footer-actions">
        <button
          type="button"
          nz-button
          nzType="default"
          (click)="mode ? backToSelection() : handleCancel()"
        >
          {{ mode ? 'Back' : 'Cancel' }}
        </button>
        <button
          type="button"
          nz-button
          nzType="primary"
          (click)="handleSubmit()"
          [nzLoading]="sending"
          [disabled]="loading || !rows.length || !mode"
          style="margin-left: 8px"
        >
          Send
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>
